import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function ImageGenerationIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<rect x="0.175768" y="0.175768" width="19.6485" height="19.6485" rx="3.82423" fill="#8800FF" />
			<rect
				x="0.175768"
				y="0.175768"
				width="19.6485"
				height="19.6485"
				rx="3.82423"
				stroke="#E7E7E7"
				strokeWidth="0.351536"
				fill="#8800FF"
			/>
			<path
				d="M7.34766 4.85547V4.36875C7.34766 4.18765 7.20085 4.04084 7.01975 4.04084H3.4535C3.2724 4.04084 3.12559 4.18765 3.12559 4.36875V4.85547"
				stroke="white"
				strokeWidth="0.78125"
				strokeMiterlimit="10"
			/>
			<path d="M5.23535 4.04127V8.31543" stroke="white" strokeWidth="0.78125" strokeMiterlimit="10" />
			<path d="M6.05371 8.12012H4.42004" stroke="white" strokeWidth="0.78125" strokeMiterlimit="10" />
			<rect
				x="10.4492"
				y="9.6748"
				width="6.03524"
				height="5.89323"
				rx="0.502403"
				stroke="white"
				strokeWidth="0.78125"
				fill="#8800FF"
			/>
			<path
				d="M14.9922 11.2314H14.9962M10.623 14.0118L12.2118 12.423C12.5804 12.0683 13.0348 12.0683 13.4034 12.423L14.595 13.6146L14.9922 13.2174C15.1153 13.0991 15.248 13.02 15.3842 12.9807"
				stroke="white"
				strokeWidth="0.78125"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.29297 7.58301L9.29297 8.82267L8.07627 8.82267"
				stroke="white"
				strokeWidth="0.78125"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.11816 8.64624L7.72765 7.22949"
				stroke="white"
				strokeWidth="0.78125"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SvgIcon>
	);
}

export default ImageGenerationIcon;
